import { z } from "zod";
import { TODO_SORT_DIRS, TODO_SORT_FIELDS } from "@/features/todos/todo-vocabulary";
import { TODO_PRIORITIES, TODO_STATUSES } from "@/shared/todos/todo-vocabulary";

export const adminTodosSearchSchema = z
  .object({
    search: z.string().optional(),
    status: z.enum(TODO_STATUSES).optional(),
    priority: z.enum(TODO_PRIORITIES).optional(),
    createdByUserId: z.string().optional(),
    assigneeUserId: z.string().optional(),
    includeDeleted: z.boolean().optional(),
    sortBy: z.enum(TODO_SORT_FIELDS).catch("sortOrder").default("sortOrder"),
    sortDir: z.enum(TODO_SORT_DIRS).catch("asc").default("asc"),
  })
  .strict();
export type AdminTodosSearch = z.infer<typeof adminTodosSearchSchema>;
